<template>
  <div id="app">
    <Header v-if="!isFullscreen" />
    <router-view v-slot="{ Component, route }">
      <component :is="Component" :key="route.fullPath || route.path" />
    </router-view>
    <Footer v-if="!isFullscreen" />
    <AuthModalHost />
    <GlobalSnackbar />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Header from '@/components/shared/Header.vue'
import Footer from '@/components/shared/Footer.vue'
import AuthModalHost from '@/components/auth/AuthModalHost.vue'
import GlobalSnackbar from '@/components/shared/GlobalSnackbar.vue'

const route = useRoute()
const isFullscreen = computed(() => !!route.meta?.fullscreen)
</script>

<style>
/* Global styles are imported in main.js */
</style>
